module.exports = __webpack_public_path__ + "static/img/img2.39204df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/img2.png
// module id = a9CN
// module chunks = 0